export default __webpack_public_path__ + "static/media/10.bb6fc54b.png";